import { ObservableArray, View } from "binder"
import { DistinguishingDetailDefinitionViewModel, DistinguishingDetailWrapper } from "./distinguishingDetailDefinition-viewModel"

export class DistinguishingDetailDefinitionView extends View<DistinguishingDetailDefinitionViewModel>{
    GetViewUniqueId(): string {
        return "V-ED0277EE-A865-434E-874A-73414AD06591"
    }
    loadHtml(): string {
        let element = require('./distinguishingDetailDefinition.html').default;
        let style = require('./distinguishingDetailDefinition.less');
        return element;
    }
    constructor() {
       super();
    }
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set details(v: ObservableArray<DistinguishingDetailWrapper>) { this._details = v; } public get details(): ObservableArray<DistinguishingDetailWrapper> { return this._details;} private _details: ObservableArray<DistinguishingDetailWrapper>;
    
    addNew(){
        this.dataContext.addNew();
    }

    update(){
        this.dataContext.update();
    }
}
